(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cr7-avisame"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', (evento) => {
    const tags = evento.target.querySelector('[data-cr7-avisame-tags]');
    if (!tags) return;
    const partes = Object.fromEntries(
      new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Mexico_City',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
      })
        .formatToParts(new Date())
        .map((p) => [p.type, p.value])
    );
    const fecha = `${partes.year}-${partes.month}-${partes.day}-${partes.hour}${partes.minute}`;
    tags.value = `${tags.dataset.cr7AvisameTags}, ${tags.dataset.cr7AvisameProducto}-${fecha}`;
  });
  } catch(e) { console.error(e); }
})();

})();
